import BuiltInStyles from '../styles/BuiltInStyles';
// NOTE(mikcol): this should only be used for typing, it should not emit an import (circular dependency)
import * as ltjsEnvironment from '../ltjsEnvironment';
import * as ltjsUtil from '../ltjsUtil';
import { BASE_RESOURCE_LOCATION } from './ltjsLoaderUtil';
var isOpenUI = sas.ltjs.isOpenUI;
var isJest = !!sas.ltjs.jest;
var _applicationThemeName = sas.ltjs.theme || 'light';
var _cssLocation = '';
var _applicationStyle = undefined;
var _defaultThemeFocusStyle = '';
ltjsEnvironment.ltjsModule.runtime.themeOverrideCallbacks.add(function (overrideCss) {
    if (!overrideCss) {
        return;
    }
    // Avoid circular dependencies.
    var StyleModule = ltjsEnvironment.moduleLookup('commons::Style');
    if (!_applicationStyle) {
        // Enums don't have circular dependencies, so BuiltInStyles is ok as is.
        _applicationStyle = new StyleModule(BuiltInStyles.NONE).retain();
    }
    _applicationStyle.clear();
    _applicationStyle.addAttributeBundlesDefinedInCSSString(overrideCss);
    // look through to the global style instance
    var sharedStyle = StyleModule.instance();
    _applicationStyle.setParentStyle(sharedStyle);
});
var ThemeUtil = (function () {
    if (!isOpenUI) {
        return undefined;
    }
    var themeUtil = sas.ltjs.require('sas/hc/ui/core/theme/ThemeUtil');
    sas.eventBus.subscribe('Themes', 'applicationThemeChanged', function () {
        if (ltjsEnvironment.isInitialized()) {
            loadApplicationTheme();
        }
    });
    return themeUtil;
})();
var GlobalSettingsHelper = (function () {
    if (!isOpenUI) {
        return undefined;
    }
    var globalSettingsHelper = sas.ltjs.require('sas/hc/ui/core/settings/GlobalSettingsHelper');
    var sasCoreLib = sas.ltjs.require('sas/hc/ui/core/library');
    sas.eventBus.subscribe(sasCoreLib.SETTINGS_CHANNEL, sasCoreLib.SETTINGS_CHANGE, overrideFocusIndicatorStyle);
    return globalSettingsHelper;
})();
export function loadApplicationTheme(platformInitCallback) {
    if (isJest) {
        if (platformInitCallback) {
            platformInitCallback();
        }
        return;
    }
    var graphCSSLocation = '';
    var loadCount = 1;
    var processResource = function () {
        loadCount--;
        // tslint:disable-next-line:strict-type-predicates
        if (loadCount === 0 && platformInitCallback && typeof platformInitCallback === 'function') {
            platformInitCallback();
        }
    };
    if (isOpenUI) {
        // tslint:disable-next-line:no-unsafe-any
        graphCSSLocation = new ThemeUtil().getGraphStylesheetUrl();
    }
    else {
        var baseThemePath = isOpenUI ? 'sas/hc/graph/themes/' : "".concat(BASE_RESOURCE_LOCATION, "/themes/");
        var linkLocation = ltjsUtil.getResourceURL("".concat(baseThemePath).concat(_applicationThemeName, "/library.css"));
        graphCSSLocation = ltjsUtil.getResourceURL("".concat(baseThemePath).concat(_applicationThemeName, "/graph.css"));
        if (!sas.ltjs.node) {
            var link_1 = document.getElementById('graph-library-css');
            if (!link_1 || link_1.href !== graphCSSLocation) {
                loadCount++;
                link_1 = link_1 || document.createElement('link');
                link_1.id = 'graph-library-css';
                link_1.rel = 'stylesheet';
                link_1.type = 'text/css';
                link_1.href = linkLocation;
                var loadHandler_1 = function () {
                    link_1.removeEventListener('load', loadHandler_1);
                    // tslint:disable-next-line:no-use-before-declare
                    link_1.removeEventListener('error', errorHandler_1);
                    processResource();
                };
                var errorHandler_1 = function () {
                    ltjsUtil.assert(false, 'Graph themes failed to load');
                    link_1.removeEventListener('load', loadHandler_1);
                    link_1.removeEventListener('error', errorHandler_1);
                    processResource();
                };
                link_1.addEventListener('load', loadHandler_1);
                link_1.addEventListener('error', errorHandler_1);
                document.head.appendChild(link_1);
            }
        }
    }
    if (graphCSSLocation && _cssLocation !== graphCSSLocation) {
        if (sas.ltjs.node) {
            sas.ltjs.node.fs.promises.readFile(graphCSSLocation).then(function (data) {
                overrideApplicationTheme(data.toString());
                processResource();
            }, function () {
                console.error("Failed to load application theme from ".concat(graphCSSLocation));
                processResource();
            });
        }
        else {
            ltjsUtil
                .ajax({
                url: graphCSSLocation,
                dataType: '*',
                processData: false,
                type: 'GET',
                headers: {
                    "Accept": "text/css"
                }
            })
                .done(function (data) {
                overrideApplicationTheme(data);
                if (isOpenUI) {
                    setDefaultThemeFocusStyle();
                    overrideFocusIndicatorStyle();
                }
            })
                .always(function () {
                processResource();
            });
        }
    }
    _cssLocation = graphCSSLocation;
}
export function overrideApplicationTheme(overrideCss) {
    ltjsEnvironment.ltjsModule.runtime.themeOverrideCallbacks.forEach(function (cb) { return cb(overrideCss); });
}
export function setApplicationTheme(name) {
    if (isOpenUI) {
        ltjsUtil.assert(false, 'OpenUI apps rely on the OpenUI config and the preference service for graph themes.');
        return;
    }
    _applicationThemeName = name || 'light';
    if (ltjsEnvironment.isInitialized()) {
        loadApplicationTheme();
    }
}
export function getApplicationTheme() {
    if (isOpenUI) {
        ltjsUtil.assert(false, 'OpenUI apps rely on the OpenUI config and the preference service for graph themes.');
        return null;
    }
    return _applicationThemeName;
}
export function getApplicationStyle() {
    return _applicationStyle;
}
function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}
function rgbToHex(r, g, b) {
    return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
}
export function overrideFocusIndicatorStyle() {
    if (!_applicationStyle)
        return;
    if (!GlobalSettingsHelper.getFocusOverride()) {
        if (!_defaultThemeFocusStyle)
            return;
        _applicationStyle.addAttributeBundlesDefinedInCSSString(_defaultThemeFocusStyle);
        return;
    }
    var colorObj = GlobalSettingsHelper.getFocusColor();
    if (!colorObj)
        return;
    var lineColor = rgbToHex(colorObj.red, colorObj.green, colorObj.blue);
    var lineThickness = GlobalSettingsHelper.getFocusThickness();
    if (!lineThickness)
        return;
    var focusCSS = ".Focus{line-color:".concat(lineColor, ";line-thickness:").concat(lineThickness, "px;line-style:2}");
    _applicationStyle.addAttributeBundlesDefinedInCSSString(focusCSS);
}
function setDefaultThemeFocusStyle() {
    if (!_applicationStyle)
        return;
    var PredefinedAttributesBundle = sas.ltjs.require('sas/ltjs/commons/styles/StyleElement');
    var StyleAttributeModule = sas.ltjs.require('sas/ltjs/commons/styles/StyleAttribute');
    var ColorUtilitiesModule = sas.ltjs.require('sas/ltjs/commons/util/ColorUtilities');
    var defaultFocusStyleAttributeBundle = _applicationStyle.getAttributeBundleForStyleElement(PredefinedAttributesBundle.GRAPH_FOCUS);
    if (!defaultFocusStyleAttributeBundle)
        return;
    var defaultLineColor = ColorUtilitiesModule.getHexStringFromColor(defaultFocusStyleAttributeBundle.getStyleAttributeUnsignedValue(StyleAttributeModule.LINE_COLOR, 0));
    if (!defaultLineColor)
        return;
    var defaultLineThicknessDimension = defaultFocusStyleAttributeBundle.getStyleAttributeDimensionValue(StyleAttributeModule.LINE_THICKNESS, null);
    if (!defaultLineThicknessDimension)
        return;
    var defaultLineThickness = defaultLineThicknessDimension.getValue();
    if (!defaultLineThickness)
        return;
    var defaultLineStyle = defaultFocusStyleAttributeBundle.getStyleAttributeUnsignedValue(StyleAttributeModule.LINE_STYLE, 0);
    if (!defaultLineStyle)
        return;
    _defaultThemeFocusStyle = ".Focus{line-color:".concat(defaultLineColor, ";line-thickness:").concat(defaultLineThickness, "px;line-style:").concat(defaultLineStyle, "}");
}
